module.exports = __webpack_public_path__ + "static/media/3.47609994.jpg";